import React, { useEffect, useState } from "react";
import { makeStyles, Container, Grid } from "@material-ui/core";
import MetaSeo from "../../../components/MetaSeo";
import ScheduleComponent from "../../../components/MainComponent/ScheduleComponent";
import moment from "moment";

const useStyles = makeStyles((theme) => ({}));

interface BoardContainerProps {
  //   children: React.ReactNode | null | string | undefined;
  match: any;
  history: any;
}

function ScheduleContainer({ match, history }: BoardContainerProps) {
  const classes = useStyles();
  const today = new Date();
  const [month, setMonth] = useState<any>(null);
  const [firstDate, setFirstDate] = useState<any>(null);
  const [secondDate, setSecondDate] = useState<any>(null);

  function isDatetime(d: any) {
    const re = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/;
    return re.test(d);
  }

  useEffect(() => {
    if (match.params.param_month) {
      const validDate = moment(`${match.params.param_month}`);
      if (validDate.isValid() == true) {
        console.log("맞음", validDate.isValid());
        console.log(match.params.param_month);
        const transDate = new Date(match.params.param_month);
        let year = transDate.getFullYear();

        let mon = transDate.getMonth();
        console.log(mon);
        console.log("date", transDate.getMonth());
        setMonth(`${year}-${mon + 1}`);
        setFirstDate(new Date(year, mon, 0));
        setSecondDate(new Date(year, mon + 1, 1));
      } else {
        const transDate = new Date(today);
        let year = transDate.getFullYear();

        let mon = transDate.getMonth();
        console.log(mon);
        console.log("date", transDate.getMonth());
        setMonth(`${year}-${mon + 1}`);
        setFirstDate(new Date(year, mon, 0));
        setSecondDate(new Date(year, mon + 1, 1));
      }
    } else {
      const transDate = new Date(today);
      let year = transDate.getFullYear();

      let mon = transDate.getMonth();
      console.log(mon);
      console.log("date", transDate.getMonth());
      setMonth(`${year}-${mon + 1}`);
      setFirstDate(new Date(year, mon, 0));
      setSecondDate(new Date(year, mon + 1, 1));
    }

    return () => {};
  }, [month]);

  return (
    <Container
      maxWidth={false}
      style={{ paddingTop: "10rem", paddingBottom: "6rem" }}
      disableGutters
    >
      <Container
        maxWidth={"xl"}
        disableGutters={true}
        style={{
          paddingLeft: "6rem",
          paddingRight: "6rem",
        }}
      >
        <MetaSeo
          data={{
            title: "노동인권문화제 일정",
            description: "노동이권문화제 행사 일정입니다",
            canonical: "http://laborbusan.or.kr/schedule/",
          }}
        />
        <Grid container>
          {/* <Grid
            item
            xs={5}
            style={{
              fontFamily: "Noto Sans KR",
              fontSize: 64,
              color: "black",
              fontWeight: 900,
              // letterSpacing: -4,
              display: "inline-block",
              paddingBottom: 32,
            }}
          >
            노동인권문화제 일정
          </Grid> */}
          <Container maxWidth={"lg"}>
            <Grid
              xs={12}
              item
              container
              // style={{ paddingLeft: "14rem", paddingRight: "14rem" }}
            >
              {/* <Grid xs={3} item>
              <ScheduleInput setMonth={setMonth} />
            </Grid> */}
              <Grid xs={12} item>
                <ScheduleComponent
                  firstDate={firstDate}
                  secondDate={secondDate}
                  month={month}
                  setMonth={setMonth}
                />
              </Grid>
            </Grid>
          </Container>
        </Grid>
        {/* <BoardListGroup match={match} history={history} /> */}
      </Container>
    </Container>
  );
}

export default ScheduleContainer;
